import { useRxData } from 'rxdb-hooks';
import { ISSListAPIResponse } from '.';

export const useSSDropdownRxDb = (): {
	data: ISSListAPIResponse[] | undefined;
	isLoading: boolean;
	error: Error | null;
} => {
	const { result: data, isFetching: isLoading } = useRxData<ISSListAPIResponse>('lms_ss_list', (collection) =>
		collection.find()
	);

	return {
		data,
		isLoading,
		error: null, // RxDB doesn't provide error in this hook
	};
};
